import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

import { validateAutoGenerateSearch } from "../hooks/useChapterNavigation";

export const Route = createFileRoute(
  "/book/$bookId/plan/$partNumber/$chapterNumber",
)({
  component: lazyRouteComponent(
    () => import("../pages/Book/components/ChapterPlanPage"),
    "ChapterPlanPage",
  ),
  validateSearch: validateAutoGenerateSearch,
});
